<app-filtros-reporte>
  <form class="space-y-3 sm:space-y-4" (submit)="aplicarFiltros($event)">
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
      <!-- Rango de fechas y tipo movimiento -->
      <div class="sm:col-span-2 lg:col-span-1">
        <label class="block text-xs sm:text-sm font-medium text-gray-600 mb-2">
          <i class="bi bi-calendar-range"></i>
          Rango de fechas
        </label>
        <div class="flex items-center rounded-lg border border-slate-200 bg-white transition-all duration-150 focus-within:ring-2 focus-within:ring-accent-500/20 focus-within:border-accent-500 hover:border-slate-300">
          <span class="flex items-center justify-center pl-3 pr-2 text-slate-400 shrink-0">
            <i class="bi bi-calendar text-sm"></i>
          </span>
          <app-datepicker
            ngSkipHydration
            class="flex-1"
            [borderless]="true"
            [formField]="$any(formFiltro.rangoFecha)"
            selectionMode="range"
            [maxDate]="maxDate"
            placeholder="Seleccione un rango"
            dateFormat="dd/mm/yy"
            [minDate]="minDate"
            [showButtonBar]="true"
            [invalid]="formFiltro.rangoFecha().touched() && formFiltro.rangoFecha().invalid()"
          />
        </div>
        @if (formFiltro.rangoFecha().touched() && formFiltro.rangoFecha().invalid()) {
          <small class="text-sm text-red-600">{{ formFiltro.rangoFecha().errors() | formErrorMessage }}</small>
        }
      </div>
      <!-- Tipo de movimiento -->
      <div class="sm:col-span-1">
        <label class="block text-xs sm:text-sm font-medium text-gray-600 mb-2">
          <i class="bi bi-arrow-left-right"></i>
          Tipo de movimiento
        </label>
        <app-select
          class="w-full"
          [options]="opcionesTipoMovimiento()"
          [formField]="$any(formFiltro.tipo_movimiento)"
          placeholder="Todos"
        />
      </div>
      <!-- Tipo de pago -->
      <div class="sm:col-span-1">
        <label class="block text-xs sm:text-sm font-medium text-gray-600 mb-2">
          <i class="bi bi-paypal"></i>
          Tipo de pago
        </label>
        <app-select
          class="w-full"
          [options]="opcionesTipoPago()"
          [formField]="$any(formFiltro.tipo_pago)"
          placeholder="Seleccione tipo de pago"
          [filter]="true"
          filterBy="label"
        />
      </div>
      <!-- Usuario -->
      <div>
        <label class="block text-sm font-medium text-gray-600 mb-2">
          <i class="bi bi-person-circle"></i>
          Empleado
        </label>
        <app-select
          class="w-full"
          [options]="optionesEmpleado()"
          [formField]="$any(formFiltro.empleado)"
          placeholder="Seleccione un empleado"
          [filter]="optionesEmpleado().length > 10"
          filterBy="label"
          emptyFilterMessage="No se encontraron empleados."
          [loading]="!optionesEmpleado().length"
        />
      </div>
      <!-- sucursal -->
      <div class="sm:col-span-2 lg:col-span-1">
        <label class="block text-xs sm:text-sm font-medium text-gray-600 mb-2">
          <i class="bi bi-geo-alt"></i>
          Sucursal
        </label>
        <app-select
          class="w-full"
          [options]="opcionesSucursal()"
          [formField]="$any(formFiltro.sucursal)"
          placeholder="Seleccione una sucursal"
          [filter]="opcionesSucursal().length > 10"
          filterBy="label"
          emptyFilterMessage="No se encontraron sucursales."
          [loading]="!opcionesSucursal().length"
        />
      </div>
    </div>
    <!-- Botones de acción -->
    <div class="grid grid-cols-3 sm:grid-cols-3 lg:grid-cols-3 gap-2 sm:gap-3">
      <button
        type="submit"
        class="px-3 sm:px-4 py-2 sm:py-2.5 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors flex items-center justify-center gap-1 sm:gap-2 text-xs sm:text-sm"
      >
        <i class="bi bi-search"></i>
        <span class="hidden sm:inline">Buscar</span>
      </button>
      <button
        type="button"
        (click)="limpiarFiltros()"
        class="px-3 sm:px-4 py-2 sm:py-2.5 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition-colors flex items-center justify-center gap-1 sm:gap-2 text-xs sm:text-sm"
      >
        <i class="bi bi-arrow-clockwise"></i>
        <span class="hidden sm:inline">Limpiar</span>
      </button>
      <button
        type="button"
        (click)="exportarExcel()"
        class="px-3 sm:px-4 py-2 sm:py-2.5 bg-emerald-600 text-white font-medium rounded-lg hover:bg-emerald-700 transition-colors flex items-center justify-center gap-1 sm:gap-2 text-xs sm:text-sm"
      >
        <i class="bi bi-file-earmark-excel"></i>
        <span class="hidden sm:inline">Excel</span>
      </button>
    </div>
  </form>
</app-filtros-reporte>
@if (resumenReporte() != null) {
  <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-2 sm:gap-3 mb-4 sm:mb-6">
    <!-- total ingresos -->
    <div class="rounded-lg shadow-sm p-3 sm:p-4 border-l-4 border-green-500">
      <div class="flex items-center gap-3">
        <div class="flex-1 min-w-0">
          <p class="text-gray-600 text-xs font-medium">Total ingresos</p>
          <p class="text-base sm:text-lg font-bold text-gray-900 mt-1 truncate">
            {{ resumenReporte()!.total_ingresos | currency: 'PEN' : 'S/. ' }}
          </p>
        </div>
        <div class="p-2 bg-green-100 rounded shrink-0">
          <i class="bi bi-cash-stack text-green-600 text-lg"></i>
        </div>
      </div>
    </div>
    <!-- total de egresos -->
    <div class="rounded-lg shadow-sm p-3 sm:p-4 border-l-4 border-red-500">
      <div class="flex items-center gap-3">
        <div class="flex-1 min-w-0">
          <p class="text-gray-600 text-xs font-medium">Total egresos</p>
          <p class="text-base sm:text-lg font-bold text-gray-900 mt-1 truncate">
            {{ resumenReporte()!.total_egresos | currency: 'PEN' : 'S/. ' }}
          </p>
        </div>
        <div class="p-2 bg-red-100 rounded shrink-0">
          <i class="bi bi-wallet2 text-red-600 text-lg"></i>
        </div>
      </div>
    </div>
    <!-- total por tipo de pagos -->
    @for (tipoPago of resumenReporte()!.total_por_tipo_pago; track $index) {
      <div class="rounded-lg shadow-sm p-3 sm:p-4 border-l-4 border-blue-500">
        <div class="flex items-center gap-3">
          <div class="flex-1 min-w-0">
            <p class="text-gray-600 text-xs font-medium truncate">
              {{ tipoPago.tipo_pago_nombre }}
            </p>
            <p class="text-base sm:text-lg font-bold text-gray-900 mt-1 truncate">
              {{ tipoPago.total | currency: 'PEN' : 'S/. ' }}
            </p>
          </div>
          <div class="p-2 bg-blue-100 rounded shrink-0">
            <i class="bi bi-wallet-fill text-blue-600 text-lg"></i>
          </div>
        </div>
      </div>
    }
  </div>
}
<app-tabla
  titulo="Movimiento en caja"
  [columnas]="columnasTabla"
  [datos]="paginacion()?.data || []"
  [accionesTemplate]="accionesTemplate"
/>
<ng-template #accionesTemplate let-row>
  <button
    type="button"
    class="text-blue-600 hover:text-blue-800 font-medium text-sm inline-flex items-center gap-1 transition-colors"
    (click)="verDetallesMovimientoCaja(row)"
  >
    <i class="bi bi-eye"></i>
    <span class="hidden sm:inline">Ver</span>
  </button>
</ng-template>
<!-- sucursal -->
<ng-template #sucursalColumnTemplate let-row>
  {{ row.sucursal_id | nombreSucursal }}
</ng-template>
@if (paginacion() != null) {
  <app-paginacion
    [items]="paginacion()!.data"
    [itemsPorPagina]="paginacion()!.size"
    [totalItems]="paginacion()!.total"
    (paginaCambiada)="cambiarPagina($event)"
  />
}
<app-dialog
  header="Detalles del Movimiento de Caja"
  [modal]="true"
  [(visible)]="modal_ver_movimientos_caja"
  (onHide)="onCloseModalVerMovimientoCaja()"
  size="lg"
  styleClass="w-[90vw] max-w-[900px]"
>
  @if (modal_ver_movimientos_caja() == true && movimiento_seleccionado() != null) {
    <div class="space-y-6">
      <!-- ================= MOVIMIENTO DE CAJA ================= -->
      <div class="bg-white border border-gray-200 rounded-xl p-5 shadow-sm">
        <div class="flex items-center justify-between mb-6">
          <h3 class="text-lg font-semibold text-gray-900">Movimiento de Caja</h3>
          @if (movimiento_seleccionado()!.venta_id !== null) {
            <app-button label="Ver venta" icon="bi bi-eye" (onClick)="verDetallesVenta()" />
          }
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <p class="label">Código de Caja</p>
            <p class="value">{{ movimiento_seleccionado()!.codigo_caja }}</p>
          </div>

          <div>
            <p class="label">Tipo</p>
            <span
              class="inline-flex px-3 py-1 rounded-full text-sm font-medium"
              [class]="{
                'bg-green-100 text-green-700':
                  movimiento_seleccionado()!.tipo === ETipoMovimientoCaja.INGRESO,
                'bg-red-100 text-red-700':
                  movimiento_seleccionado()!.tipo === ETipoMovimientoCaja.EGRESO,
              }"
            >
              {{ movimiento_seleccionado()!.tipo }}
            </span>
          </div>

          <div>
            <p class="label">Empleado</p>
            <p class="value">{{ movimiento_seleccionado()!.usuario_nombre_completo }}</p>
            <p class="text-xs text-gray-500">{{ movimiento_seleccionado()!.usuario_email }}</p>
          </div>

          <div>
            <p class="label">Tipo de Pago</p>
            <p class="value">{{ movimiento_seleccionado()!.tipo_pago_nombre }}</p>
          </div>

          <div>
            <p class="label">Fecha</p>
            <p class="value">
              {{ movimiento_seleccionado()!.fecha | date: 'dd/MM/yyyy HH:mm' }}
            </p>
          </div>

          <div class="md:col-span-2">
            <p class="label">Monto</p>
            <p class="text-3xl font-bold text-gray-900">
              {{ movimiento_seleccionado()!.monto | currency: 'PEN' : 'S/. ' }}
            </p>
          </div>

          @if (movimiento_seleccionado()!.descripcion) {
            <div class="md:col-span-2">
              <p class="label">Descripción</p>
              <p class="text-gray-700">{{ movimiento_seleccionado()!.descripcion }}</p>
            </div>
          }
        </div>
      </div>

      <!-- ================= VENTA ================= -->
      <app-ver-venta #verVentaComponent />
    </div>
  }
</app-dialog>
